export type MinisterioEscalaParticipanteStatus = 'confirmado' | 'pendente' | 'ausente'

export interface MinisterioEscalaParticipante {
  id: string
  nome: string
  funcao: string
  status: MinisterioEscalaParticipanteStatus
}

export interface MinisterioEscalaItem {
  id: string
  data: string
  atividade: string
  descricao: string
  membros: MinisterioEscalaParticipante[]
}

export type MinisterioTimelineCategoria = 'reuniao' | 'culto' | 'treinamento' | 'acao'

export interface MinisterioTimelineEvento {
  id: string
  data: string
  titulo: string
  descricao: string
  categoria: MinisterioTimelineCategoria
  destaque?: boolean
}

export interface MinisterioParticipacaoMensal {
  mes: string
  percentual: number
  presencas: number
  total: number
}

export interface MinisterioParticipacaoResumo {
  membroId: string
  nome: string
  funcao: string
  presencas: number
  ausencias: number
  ultimaParticipacao: string
}

export const mockMinisterioEscalas: Record<string, MinisterioEscalaItem[]> = {
  '1': [
    {
      id: 'escala-1',
      data: '2024-11-03T18:30:00-03:00',
      atividade: 'Culto de Celebração',
      descricao:
        'Responsáveis pela condução do louvor e suporte técnico do culto de celebração do primeiro domingo.',
      membros: [
        { id: 'm-1', nome: 'Ana Souza', funcao: 'Vocal principal', status: 'confirmado' },
        { id: 'm-2', nome: 'Carlos Lima', funcao: 'Guitarra', status: 'confirmado' },
        { id: 'm-3', nome: 'Mariana Alves', funcao: 'Teclado', status: 'pendente' },
        { id: 'm-4', nome: 'Paulo Ribeiro', funcao: 'Técnico de som', status: 'confirmado' },
      ],
    },
    {
      id: 'escala-2',
      data: '2024-11-10T18:30:00-03:00',
      atividade: 'Culto Jovem',
      descricao: 'Equipe responsável pelo momento de louvor e suporte aos testemunhos dos jovens.',
      membros: [
        { id: 'm-2', nome: 'Carlos Lima', funcao: 'Guitarra', status: 'confirmado' },
        { id: 'm-5', nome: 'Juliana Pereira', funcao: 'Back vocal', status: 'confirmado' },
        { id: 'm-6', nome: 'Rafael Gomes', funcao: 'Bateria', status: 'ausente' },
      ],
    },
    {
      id: 'escala-3',
      data: '2024-11-17T18:30:00-03:00',
      atividade: 'Ensaio Geral de Natal',
      descricao:
        'Preparação do repertório especial de Natal com ensaio completo de toda a equipe de louvor.',
      membros: [
        { id: 'm-1', nome: 'Ana Souza', funcao: 'Vocal principal', status: 'confirmado' },
        { id: 'm-3', nome: 'Mariana Alves', funcao: 'Teclado', status: 'confirmado' },
        { id: 'm-7', nome: 'Diego Martins', funcao: 'Baixo', status: 'pendente' },
      ],
    },
  ],
  '2': [
    {
      id: 'escala-4',
      data: '2024-11-02T16:00:00-03:00',
      atividade: 'Encontro de Jovens',
      descricao: 'Equipe de recepção e dinâmica do encontro semanal de jovens.',
      membros: [
        { id: 'j-1', nome: 'Luiza Castro', funcao: 'Coordenação', status: 'confirmado' },
        { id: 'j-2', nome: 'Pedro Henrique', funcao: 'Intercessão', status: 'confirmado' },
        { id: 'j-3', nome: 'Bianca Ramos', funcao: 'Dinâmica', status: 'pendente' },
      ],
    },
    {
      id: 'escala-5',
      data: '2024-11-09T10:00:00-03:00',
      atividade: 'Visita ao Lar Abrigo Esperança',
      descricao: 'Equipe de jovens responsável por ações sociais e evangelismo no abrigo parceiro.',
      membros: [
        { id: 'j-1', nome: 'Luiza Castro', funcao: 'Coordenação', status: 'confirmado' },
        { id: 'j-4', nome: 'Miguel Santos', funcao: 'Louvor', status: 'confirmado' },
        { id: 'j-5', nome: 'Isabela Rocha', funcao: 'Artes', status: 'ausente' },
      ],
    },
  ],
  '3': [
    {
      id: 'escala-6',
      data: '2024-11-03T09:30:00-03:00',
      atividade: 'Aula bíblica infantil',
      descricao:
        'Escala dos professores e auxiliares para a aula bíblica das crianças de 6 a 8 anos.',
      membros: [
        { id: 'c-1', nome: 'Fernanda Souza', funcao: 'Professora principal', status: 'confirmado' },
        { id: 'c-2', nome: 'João Victor', funcao: 'Assistente', status: 'confirmado' },
        { id: 'c-3', nome: 'Helena Prado', funcao: 'Apoio criativo', status: 'pendente' },
      ],
    },
    {
      id: 'escala-7',
      data: '2024-11-10T09:30:00-03:00',
      atividade: 'Oficina de música infantil',
      descricao: 'Momentos lúdicos com instrumentos e ensino musical para as crianças.',
      membros: [
        { id: 'c-4', nome: 'Bruno Nunes', funcao: 'Instrutor', status: 'confirmado' },
        { id: 'c-5', nome: 'Patrícia Silva', funcao: 'Suporte pedagógico', status: 'confirmado' },
        { id: 'c-6', nome: 'Laura Ribeiro', funcao: 'Contação de histórias', status: 'ausente' },
      ],
    },
  ],
}

export const mockMinisterioTimeline: Record<string, MinisterioTimelineEvento[]> = {
  '1': [
    {
      id: 'timeline-1',
      data: '2024-10-20T19:00:00-03:00',
      titulo: 'Noite de adoração e oração',
      descricao:
        'Reunião especial com todos os integrantes para alinhamento espiritual e ensaio coletivo.',
      categoria: 'reuniao',
      destaque: true,
    },
    {
      id: 'timeline-2',
      data: '2024-09-15T18:30:00-03:00',
      titulo: 'Capacitação técnica de áudio',
      descricao: 'Treinamento sobre mixagem e ajustes do sistema de som da igreja.',
      categoria: 'treinamento',
    },
    {
      id: 'timeline-3',
      data: '2024-08-25T18:30:00-03:00',
      titulo: 'Culto especial de ações de graças',
      descricao: 'Participação ativa do ministério de louvor na celebração anual da igreja.',
      categoria: 'culto',
    },
  ],
  '2': [
    {
      id: 'timeline-4',
      data: '2024-10-12T15:00:00-03:00',
      titulo: 'Retiro de primavera',
      descricao: 'Dia de comunhão, mentoria e planejamento do calendário trimestral.',
      categoria: 'reuniao',
      destaque: true,
    },
    {
      id: 'timeline-5',
      data: '2024-08-03T19:00:00-03:00',
      titulo: 'Culto jovem temático',
      descricao: 'Celebração organizada pelo ministério com foco em novos visitantes.',
      categoria: 'culto',
    },
  ],
  '3': [
    {
      id: 'timeline-6',
      data: '2024-09-28T09:00:00-03:00',
      titulo: 'Treinamento de segurança infantil',
      descricao: 'Capacitação para novos voluntários sobre protocolos e segurança das crianças.',
      categoria: 'treinamento',
    },
    {
      id: 'timeline-7',
      data: '2024-08-10T10:00:00-03:00',
      titulo: 'Ação social - Dia das Crianças',
      descricao: 'Visita a orfanato com oficinas, contação de histórias e atividades recreativas.',
      categoria: 'acao',
      destaque: true,
    },
  ],
}

export const mockMinisterioParticipacaoMensal: Record<string, MinisterioParticipacaoMensal[]> = {
  '1': [
    { mes: '2024-05-01', percentual: 82, presencas: 18, total: 22 },
    { mes: '2024-06-01', percentual: 88, presencas: 21, total: 24 },
    { mes: '2024-07-01', percentual: 79, presencas: 19, total: 24 },
    { mes: '2024-08-01', percentual: 91, presencas: 21, total: 23 },
    { mes: '2024-09-01', percentual: 86, presencas: 18, total: 21 },
    { mes: '2024-10-01', percentual: 93, presencas: 25, total: 27 },
  ],
  '2': [
    { mes: '2024-05-01', percentual: 74, presencas: 14, total: 19 },
    { mes: '2024-06-01', percentual: 77, presencas: 17, total: 22 },
    { mes: '2024-07-01', percentual: 81, presencas: 18, total: 22 },
    { mes: '2024-08-01', percentual: 76, presencas: 16, total: 21 },
    { mes: '2024-09-01', percentual: 83, presencas: 20, total: 24 },
    { mes: '2024-10-01', percentual: 85, presencas: 22, total: 26 },
  ],
  '3': [
    { mes: '2024-05-01', percentual: 88, presencas: 22, total: 25 },
    { mes: '2024-06-01', percentual: 92, presencas: 23, total: 25 },
    { mes: '2024-07-01', percentual: 90, presencas: 21, total: 23 },
    { mes: '2024-08-01', percentual: 95, presencas: 24, total: 25 },
    { mes: '2024-09-01', percentual: 91, presencas: 21, total: 23 },
    { mes: '2024-10-01', percentual: 94, presencas: 24, total: 26 },
  ],
}

export const mockMinisterioParticipacaoResumo: Record<string, MinisterioParticipacaoResumo[]> = {
  '1': [
    {
      membroId: 'm-1',
      nome: 'Ana Souza',
      funcao: 'Vocal principal',
      presencas: 23,
      ausencias: 2,
      ultimaParticipacao: '2024-10-27T18:30:00-03:00',
    },
    {
      membroId: 'm-2',
      nome: 'Carlos Lima',
      funcao: 'Guitarra',
      presencas: 21,
      ausencias: 4,
      ultimaParticipacao: '2024-10-27T18:30:00-03:00',
    },
    {
      membroId: 'm-3',
      nome: 'Mariana Alves',
      funcao: 'Teclado',
      presencas: 18,
      ausencias: 6,
      ultimaParticipacao: '2024-10-20T18:30:00-03:00',
    },
  ],
  '2': [
    {
      membroId: 'j-1',
      nome: 'Luiza Castro',
      funcao: 'Coordenação',
      presencas: 20,
      ausencias: 3,
      ultimaParticipacao: '2024-10-19T16:00:00-03:00',
    },
    {
      membroId: 'j-2',
      nome: 'Pedro Henrique',
      funcao: 'Intercessão',
      presencas: 18,
      ausencias: 5,
      ultimaParticipacao: '2024-10-19T16:00:00-03:00',
    },
    {
      membroId: 'j-3',
      nome: 'Bianca Ramos',
      funcao: 'Dinâmica',
      presencas: 15,
      ausencias: 7,
      ultimaParticipacao: '2024-09-28T16:00:00-03:00',
    },
  ],
  '3': [
    {
      membroId: 'c-1',
      nome: 'Fernanda Souza',
      funcao: 'Professora principal',
      presencas: 22,
      ausencias: 2,
      ultimaParticipacao: '2024-10-20T09:30:00-03:00',
    },
    {
      membroId: 'c-2',
      nome: 'João Victor',
      funcao: 'Assistente',
      presencas: 21,
      ausencias: 3,
      ultimaParticipacao: '2024-10-20T09:30:00-03:00',
    },
    {
      membroId: 'c-3',
      nome: 'Helena Prado',
      funcao: 'Apoio criativo',
      presencas: 17,
      ausencias: 7,
      ultimaParticipacao: '2024-10-13T09:30:00-03:00',
    },
  ],
}
